import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtPct, fmtUsd } from "@/lib/api";
import { TYPE_META } from "@/pages/Journal";

// Compact strip of the user's latest journal decisions for the Strategy Lab live section.
export const RecentDecisions = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/journal", { params: { limit: 8 } }).then((r) => setRows(r.data.entries)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="skeleton h-12" />;
  return (
    <div className="mt-4" data-testid="recent-decisions">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold">Your recent live decisions (journal)</h3>
        <Link to="/journal" className="text-[11px] text-cyan-300 hover:underline" data-testid="recent-decisions-link">Full journal →</Link>
      </div>
      {rows.length === 0 ? <div className="text-xs text-slate-500" data-testid="recent-decisions-empty">No decisions logged yet — trades, AI analyses, brackets and notes will appear here with their indicator snapshots.</div> : (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {rows.map((e) => { const m = TYPE_META[e.type] || TYPE_META.note; return (
            <Link key={e.id} to={`/coin/${e.coin_id}`} className={`shrink-0 w-44 rounded-lg border p-2 text-[11px] ${m.cls}`} data-testid={`recent-decision-${e.id}`}>
              <div className="flex justify-between font-mono-ticker"><span className="font-semibold">{(e.symbol || "").toUpperCase()}</span><span>{m.label}</span></div>
              <div className="text-slate-400 mt-0.5">{e.price != null ? fmtUsd(e.price) : "—"}{e.snapshot?.rsi != null ? ` · RSI ${e.snapshot.rsi.toFixed(0)}` : ""}</div>
              <div className="flex justify-between mt-0.5 text-slate-500"><span>{new Date(e.created_at).toLocaleDateString()}</span>{e.move_since_pct != null && <span className={e.move_since_pct >= 0 ? "text-emerald-300" : "text-red-300"}>{fmtPct(e.move_since_pct)}</span>}</div>
            </Link>
          ); })}
        </div>
      )}
    </div>
  );
};
